/** @format */

import * as React from 'react';

export const IconDismiss = () => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0.5 0.5L12.5 12.5M12.5 0.5L0.5 12.5" stroke="black" />
        </svg>
    );
};
